/**
 * Minimal shape of the i18next `t` function this module needs. Declaring it locally keeps the
 * helper free of i18next's generic key typing while still accepting the `t` from `useTranslation`.
 */
type Translate = (key: string) => string;

/**
 * Formats a cook time in minutes as a short, human readable label - `45 min`, `1 h 30 min`, `3 h`.
 *
 * @param minutes The cook time in minutes
 * @param t The translation function, used for the `minutesShort` / `hoursShort` units
 * @return The formatted label, or an empty string if there is no usable cook time
 */
export function formatCookTime(minutes: number | undefined | null, t: Translate): string {
  if (!minutes || minutes <= 0) return '';

  if (minutes < 60) return `${minutes} ${t('minutesShort')}`;

  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  const hoursLabel = `${hours} ${t('hoursShort')}`;

  return remainder ? `${hoursLabel} ${remainder} ${t('minutesShort')}` : hoursLabel;
}
